// extracted by mini-css-extract-plugin
export default {"zoomModal":"J5-z","image":"K5-z","button":"L5-z","isOverlayShown":"M5-z"};